module.exports = __webpack_public_path__ + "img/bg_login_m.37588724.png";